import type { IconProps } from '../types/IconProps.ts';
export const SunDim: IconProps = {
    name: 'SunDim',
    children: [
        `<path d="M12 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8" />`,
        `<circle cx="4" cy="12" r=".5" />`,
        `<circle cx="12" cy="4" r=".5" />`,
        `<circle cx="20" cy="12" r=".5" />`,
        `<circle cx="12" cy="20" r=".5" />`,
        `<circle cx="6" cy="18" r=".5" />`,
        `<circle cx="6" cy="6" r=".5" />`,
        `<circle cx="18" cy="6" r=".5" />`,
        `<circle cx="18" cy="18" r=".5" />`,
    ]
};